import { IconButton } from '@/components';
import { goBackSafe, toggleFullscreen } from '@/utils';
import { useFullscreenState } from '@ai-indeed/hooks';
import type { FC } from 'react';
import './index.less';
import type { IProps } from './types';

export const Header: FC<IProps> = (props) => {
  // props
  const { title, actions, children, onBackBefore } = props;
  // fullscreen state
  const isFullscreen = useFullscreenState();
  // methods
  const back = () =>
    new Promise<void>((resolve, reject) => {
      if (typeof onBackBefore === 'function') {
        onBackBefore(resolve, reject);
        return;
      }

      resolve();
    }).then(() => {
      if (isFullscreen) {
        toggleFullscreen();
      }
      goBackSafe();
    });

  return (
    <header className="flex justify-between items-center h-15 px-6 bg-white">
      <section className="flex gap-2 items-center">
        <IconButton
          title="返回"
          className="text-xl"
          iconType="icon-fanhui"
          onClick={back}
        />
        {title}
      </section>
      {children}
      <section className="flex gap-4 items-center">
        <IconButton
          className="text-base"
          title={isFullscreen ? '退出全屏' : '全屏'}
          iconType={isFullscreen ? 'icon-tuichuquanping' : 'icon-quanping'}
          onClick={() => toggleFullscreen()}
        />
        {actions}
      </section>
    </header>
  );
};

export type { IProps } from './types';
